<div class="ambassador-section">
  <!-- Background Mask -->
  <div class="background-mask">
    <img src="/assets/images/purple_background_vector.png" alt="Purple Background">
  </div>

  <!-- Flex Container -->
  <div class="flex-container">
    <!-- Content Section -->
    <div class="content">
      <h2>
        Access to our <span class="ambassador-text">ambassador</span> <span class="program-text">program</span>
      </h2>
      <p>We want you to make extra $$ while exploring the globe—whether you're backpacking across Asia or eating tapas in Spain.</p>
      <a class="btn btn-theme btn-large btn-icon" target="_blank" [routerLink]="['/ambassador-program']">
        <span>Earn more as you travel</span>
        <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 15.2, 'height.px': 15.2}" src="/assets/icons/arrow_right.svg"></svg-icon>
      </a>
    </div>

    <!-- Ambassador Image Section -->
    <div class="ambassador-image">
      <img src="/assets/images/ambassador_section_image.webp" alt="Ambassador Image">
    </div>
  </div>
</div>
